import { Component } from '@angular/core';
import { ChartModule } from 'primeng/chart';

@Component({
  selector: 'rc-line-chart',
  standalone: true,
  imports: [ChartModule],
  templateUrl: './generic-line-chart.component.html',
  styleUrl: './generic-line-chart.component.scss'
})
export class GenericLineChartComponent extends Component {
  chartData:any = {
            labels: ['Q1', 'Q2', 'Q3', 'Q4'],
            datasets: [
                {
                    label: 'Sales',
                    data: [540, 325, 702, 620],
                    backgroundColor: ['rgba(255, 159, 64, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(153, 102, 255, 0.2)'],
                    borderColor: ['rgb(255, 159, 64)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)'],
                    borderWidth: 1
                }
            ]
        };

  chartOptions:any = {
            plugins: {
                legend: {
                    labels: {
                        color: "white"
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        color: "grey"
                    },
                    grid: {
                        color: "green",
                        drawBorder: false
                    }
                },
                x: {
                    ticks: {
                        color: "blue"
                    },
                    grid: {
                        color: "red",
                        drawBorder: false
                    }
                }
            }
        };
}
